import axios from "../../axios";
function getMonday(d) {
  d = new Date(d);
  var day = d.getDay(),
    diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
  return new Date(d.setDate(diff));
}
function formatTime(time) {
  const [hours, minutes] = time.match(/.{1,2}/g);
  return `${hours}:${minutes}:00`;
}
let lecturesArray = [];
let plannerArray = [];
/**
 * Gets sf time table
 * @returns
 */
let startday1;
let endday1;
let date;
let start_time1;
let end_time1;
let start_time;
let end_time;
export const getTimeTable = async (startDay, endDay) => {
  console.log(startDay, endDay);
  //these dates we are getting from the calendar.
  const startday = startDay;
  const lastday = endDay;

  const dateFormatToGetdate = (date) => {
    const startdate = new Date(date);
    const outputDate = startdate.toUTCString().replace(",", "");
    let outputDate1 = outputDate.concat("+0530");
    return outputDate1;
  };
  function convertDateFormat(dateString) {
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const convertedDate = `${year}-${month}-${day}`;
    return convertedDate;
  }
  lecturesArray = [];
  function pushUniqueObjectToArray(object, array) {
    // Check for uniqueness based on both `id` and `lectureType`
    const isUnique = array.every(
      (item) => item.id !== object.id
    );
    if (isUnique) {
      array.push(object);
    }
  }
  plannerArray = [];
  function pushUniqueObjectToPlannerArray(object, array) {
    const isUnique = array.every(
      (item) => item.lecture_id !== object.lecture_id
    );
    if (isUnique) {
      array.push(object);
    }
  }

  startday1 = dateFormatToGetdate(startday);
  endday1 = dateFormatToGetdate(lastday);
  let finalStartDay = new Date(startday1);
  let finalendDay = new Date(endday1);
  const timeForAll = () => {
    let inputDate = startday;
    let date = new Date(inputDate);
    let year = date.getUTCFullYear();
    let month = String(date.getUTCMonth() + 1).padStart(2, "0");
    let day = String(date.getUTCDate()).padStart(2, "0");
    let formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const dateForAll = (item, tag) => {
    start_time = formatTime(item.start_time);
    end_time = formatTime(item.end_time);
    function formatTime(time) {
      var timeString = time.toString();
      while (timeString.length < 4) {
        timeString = "0" + timeString;
      }
      return timeString.slice(0, 2) + ":" + timeString.slice(2, 4) + ":00";
    }
    if (tag === "start") {
      return ` ${start_time} GMT+0530 (India Standard Time)`;
    } else {
      return ` ${end_time} GMT+0530 (India Standard Time)`;
    }
  };
  const resTimeManageStart = (item) => {
    start_time1 = formatTime(item.start_time);
    end_time1 = formatTime(item.end_time);
    const dayMap = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };
    let dayNo = dayMap[item.day];
    const startTimestamp = finalStartDay.getTime();
    const endTimestamp = finalendDay.getTime();
    for (
      let timestamp = startTimestamp;
      timestamp <= endTimestamp;
      timestamp += 24 * 60 * 60 * 1000
    ) {
      date = new Date(timestamp);
      if (date.getDay() === dayNo) {
        const dateString = date;
        const date1 = new Date(dateString);
        let formattedDate = date1.toDateString();
        formattedDate = formattedDate.concat(
          ` ${start_time1} GMT+0530 (India Standard Time)`
        );
        return formattedDate;
      }
    }
    return null;
  };
  const resTimeManageEnd = (item) => {
    const dayMap = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };
    let dayNo = dayMap[item.day];
    // Convert the start and end dates to UTC timestamps
    const startTimestamp = finalStartDay.getTime();
    const endTimestamp = finalendDay.getTime();
    // Loop through all dates between the start and end dates
    for (
      let timestamp = startTimestamp;
      timestamp <= endTimestamp;
      timestamp += 24 * 60 * 60 * 1000
    ) {
      date = new Date(timestamp);
      if (date.getDay() === dayNo) {
        const dateString = date;
        const date1 = new Date(dateString);
        let formattedDate = date1.toDateString();
        formattedDate = formattedDate.concat(
          ` ${end_time1} GMT+0530 (India Standard Time)`
        );
        return formattedDate;
      }
    }
    // If no matching date was found, return null
    return null;
  };
  let startDate = convertDateFormat(startday);
  let endDate = convertDateFormat(lastday);
  let variables = JSON.parse(localStorage.getItem("breathForStudent"));
  let finalArr = [];
  let response1 = [];
  var response2 = [];
  try {
    let res = await axios.get(
      `/timetable/getTimetableAndStudyPlanner/academicYearId/${variables?.academic_year?.id}/schoolId/${variables?.school?.id}/standardId/${variables?.standard?.id}/sectionId/${variables?.section?.id}/timetableSessionId/${variables?.timetable_session?.id}/studentId/${variables?.id}?startDate=${startDate}&endDate=${endDate}`
      //`/timetable/getTimetableAndStudyPlanner/academicYearId/638d69e19c3aacfcfd7b064c/schoolId/638d72aa9c3aacfcfd7b064f/standardId/62e187861a52dec56f62981b/sectionId/62d98b7c072943b9cff68672/timetableSessionId/638d6a4e9c3aacfcfd7b064d/studentId/638dee5fc4d6787791bfa3b2?startDate=${startDate}&endDate=${endDate}`
    );
    const helper4 = (item) => {
      return Object.entries(item).map(([name, value]) => ({ name, value }));
    };
    const helper3 = (supplements) => {
      response2 = [];
      response1 = [];
      const filtered = Object.entries(supplements || {})
        .filter(([key, value]) => value !== null)
        .reduce((obj, [key, value]) => {
          if (obj === undefined) {
            return undefined;
          }
          if (obj === null) {
            return null;
          }
          obj[key] = value;
          delete obj.id;
          return obj;
        }, {});
      if (
        filtered.pre_read ||
        filtered.homework ||
        filtered.assessment ||
        filtered.bbb_lecture ||
        filtered.activity
      ) {
        response1.push(filtered);
      }
      response1.forEach((i) => {
        response2 = helper4(i);
      });
      return response2;
    };
    res.data.data.forEach((obj) => {
      obj?.studyPlanner?.schedules?.forEach((object) => {
        object.lectures.forEach((lecture, index) => {
          console.log("obj.studyPlanner", lecture)
          const lectureObject = {
            Id: index + 1,
            lecture_id: lecture.id,
            studyPlanner_id: obj.studyPlanner.id,
            Subject: lecture.subject.name,
            Subject_id: lecture.subject.id,
            StartTime: resTimeManageStart(lecture),
            EndTime: resTimeManageEnd(lecture),
            // IsAllDay: lecture?.recurrence ? true : false,
            SupplementId: lecture?.supplements?.id,
            bbb_lecture_id: lecture?.supplements?.bbb_lecture,
            Events: ["Planner"],
            DisplayColor: "#" + lecture?.subject?.color,
            Recurrence: lecture?.recurrence,
            // RecurrenceRule: `FREQ=${
            //   lecture.recurrence === true ? "DAILY" : "WEEKLY"
            // };INTERVAL=1;`,
            description: lecture.description,
            name: lecture.name,
          };
          pushUniqueObjectToPlannerArray(lectureObject, plannerArray);
        });
      });
      obj?.timetable?.schedules?.forEach((obj) => {
        obj.special_lectures?.forEach((lecture, index) => {
             console.log("obj.special_lectures", lecture)
          const lectureObject = {
            Id: index + 1,
            id: lecture.id,
            Subject: lecture.subject?.name,
            name: lecture?.name,
            // StartTime: `${timeForAll()}${dateForAll(lecture, "start")}`,
            // EndTime: `${timeForAll()}${dateForAll(lecture, "end")}`,
            StartTime: resTimeManageStart(lecture),
            EndTime: resTimeManageEnd(lecture),
            IsAllDay: false,
            Events: helper3(lecture.supplements),
            SupplementId: lecture?.supplements?.id,
            bbb_lecture_id: lecture?.supplements?.bbb_lecture,
            Teacher: {
              id: lecture?.teacher?.id,
              name: lecture?.teacher?.name,
            },
            lectureName: lecture.name,
            lectureType: "special_lecture",
            DisplayColor: "#00008B",
            RecurrenceRule: `FREQ=${lecture.day === "All" ? "DAILY" : "WEEKLY"
              };INTERVAL=1;`,
          };
          pushUniqueObjectToArray(lectureObject, lecturesArray);
        });
        obj.lectures?.forEach((lecture, index) => {
           console.log("obj.special_lectures", lecture)
          const lectureObject = {
            Id: index + 1,
            id: lecture.id,
            Subject: lecture.subject?.name,
            name: lecture?.name,
            StartTime: resTimeManageStart(lecture),
            EndTime: resTimeManageEnd(lecture),
            IsAllDay: false,
            Events: helper3(lecture?.supplements),
            SupplementId: lecture?.supplements?.id,
            bbb_lecture_id: lecture?.supplements?.bbb_lecture,
            Teacher: {
              id: lecture?.teacher?.id,
              name: lecture?.teacher?.name,
            },
            DisplayColor: "#" + lecture?.subject?.color,
            lectureType: "lectures",
            lectureName: lecture.name,
            RecurrenceRule: `FREQ=${lecture.IsAllDay === true ? "DAILY" : "WEEKLY"
              };INTERVAL=1;`,
          };
          pushUniqueObjectToArray(lectureObject, lecturesArray);
        });
        obj.general_categories?.forEach((lecture, index) => {
          console.log("obj.general_categories", lecture)
          const lectureObject = {
            Id: index + 1,
            id: lecture.id,
            Subject: lecture.name,
            StartTime: resTimeManageStart(lecture),
            EndTime: resTimeManageEnd(lecture),
            IsAllDay: false,
            Events: helper3(lecture.supplements),
            SupplementId: lecture?.supplements?.id,
            bbb_lecture_id: lecture?.supplements?.bbb_lecture,
            //I am harcoding this because not getting subject in the api response for generalCategories.
            // DisplayColor: "#F3F3F3",
            lectureType: "general_category",
            lectureName: lecture.name,
            RecurrenceRule: `FREQ=${lecture.day === "All" ? "DAILY" : "WEEKLY"
              };INTERVAL=1;`,
          };
          pushUniqueObjectToArray(lectureObject, lecturesArray);
        });
        obj.proxy_lectures?.forEach((lecture, index) => {
          const lectureObject = {
            Id: index + 1,
            id: lecture.id,
            Subject: lecture.name,
            StartTime: resTimeManageStart(lecture),
            EndTime: resTimeManageEnd(lecture),
            IsAllDay: false,
            Events: helper3(lecture.supplements),
            SupplementId: lecture?.supplements?.id,
            bbb_lecture_id: lecture?.supplements?.bbb_lecture,
            DisplayColor: "#" + lecture?.subject?.color,
            RecurrenceRule: `FREQ=${lecture.day === "All" ? "DAILY" : "WEEKLY"
              };INTERVAL=1;`,
            lectureType: "proxy_lecture",
          };
          pushUniqueObjectToArray(lectureObject, lecturesArray);

        });
      });
    });
    finalArr = plannerArray.concat(lecturesArray);
  } catch (error) {
    console.log(error);
  }
  let dropDown = localStorage.getItem("dropdownval");
  return [finalArr, lecturesArray, plannerArray]
  // if (dropDown == "0") {
  //   return [finalArr]; 
  // } else if (dropDown == "1") {
  //   return [lecturesArray]; 
  // } else if (dropDown == "2") {
  //   return plannerArray;
  // } else {
  //   return [];
  // }
};
